import { render, staticRenderFns } from "./EditHistoryTable.vue?vue&type=template&id=c65e2a3e&scoped=true"
import script from "./EditHistoryTable.vue?vue&type=script&lang=js"
export * from "./EditHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./EditHistoryTable.vue?vue&type=style&index=0&id=c65e2a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65e2a3e",
  null
  
)

export default component.exports